import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ConstantsService} from '../services/constants-service';
import {CookieService} from '../services/cookie.service';
import {DomSanitizer} from '@angular/platform-browser';
import {EntityOtherComponent} from '../entities/other/entity-other.component';
import {ActivatedRoute, Router} from '@angular/router';
import {EntityDetailsService} from '../entities/details/entity-details.service';
import {EntityOtherService} from '../entities/other/entity-other.service';
import {EntityIdDetails} from '../shared/models/entity-id-details.model';

@Component({
  selector: 'app-entity-new-caf',
  templateUrl: './entity-new-caf.component.html',
  styleUrls: ['./entity-new-caf.component.css']
})
export class EntityNewCafComponent extends EntityOtherComponent implements OnInit, AfterViewInit {
  private newCafUrl = ConstantsService.NEW_CAF_URL;
  entityIdDetails: EntityIdDetails;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public domSanitizer: DomSanitizer,
    public entityDetailsService: EntityDetailsService,
    public entityOtherService: EntityOtherService,
    private cookieService: CookieService,
    private sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef) {
    super(route, router, domSanitizer, entityDetailsService, entityOtherService);
  }

  public safeUrl = () => {
    const access = this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN);
    return this.sanitizer
      .bypassSecurityTrustResourceUrl(`${this.newCafUrl}?entity=${this.entityIdDetails.entityId}&access=${access}`);
  }

  ngAfterViewInit(): void {

    this.ref.detach();
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    this.entityDetailsService.entityDetailsUpdated.subscribe(
      (entityDetails) => {
        this.entityIdDetails = entityDetails;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/entity-new-caf/entity-new-caf.component.ts